import api from '~/services/api';
import { type JSONEntitlements } from '~/types/Entitlements';

export const getEntitlements = () =>
  api.request<JSONEntitlements>({
    method: 'GET',
    url: '/entitlements',
  });
